import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { ReactElement } from 'react';
import createBrowserHistory from 'history/createBrowserHistory';
import { History } from 'history';
import { AppProvider } from './components/AppProvider';

export class Core {

  private history: History = createBrowserHistory();

  boot(rootComponent: ReactElement<{}>, rootElement: (HTMLElement | null)): Promise<void> {
    if (rootElement === null) {
      throw new Error(`[CORE] Invalid rootElement !`);
    }
    return new Promise<void>((resolve, reject) => {
      ReactDOM.render(
        this.renderCore(rootComponent),
        rootElement,
        () => resolve()
      );
    });
  }

  getHistory(): History {
    return this.history;
  }

  renderCore(rootComponent: ReactElement<{}>): ReactElement<{}> {
    return (
      <AppProvider app={this}>
        {rootComponent}
      </AppProvider>
    );
  }

}



// WEBPACK FOOTER //
// src/app/src/core/Core.tsx